import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import completions from '~root/src/components/completions.vue?shadow'
window.customElements.define('searchbooster-completions', wrap(Vue, completions))

import complex from '~root/src/components/complex.vue?shadow'
window.customElements.define('searchbooster-complex', wrap(Vue, complex))

import imageSearch from '~root/src/components/image-search.vue?shadow'
window.customElements.define('searchbooster-image-search', wrap(Vue, imageSearch))

import offers from '~root/src/components/offers.vue?shadow'
window.customElements.define('searchbooster-offers', wrap(Vue, offers))

import recommendations from '~root/src/components/recommendations.vue?shadow'
window.customElements.define('searchbooster-recommendations', wrap(Vue, recommendations))

import searchPopup from '~root/src/components/search-popup.vue?shadow'
window.customElements.define('searchbooster-search-popup', wrap(Vue, searchPopup))

import searchResultsBlock from '~root/src/components/search-results-block.vue?shadow'
window.customElements.define('searchbooster-search-results-block', wrap(Vue, searchResultsBlock))

import searchResults from '~root/src/components/search-results.vue?shadow'
window.customElements.define('searchbooster-search-results', wrap(Vue, searchResults))

import voicePopup from '~root/src/components/voice-popup.vue?shadow'
window.customElements.define('searchbooster-voice-popup', wrap(Vue, voicePopup))